import { deleteApiDocument } from "./deleteApiDocument";
import { getApiDocument } from "./getApiDocument";
import { getApiDocumentGetBenefitDocument } from "./getApiDocumentGetBenefitDocument";
import { getApiDocumentGetDocumentElectionuploadid } from "./getApiDocumentGetDocumentElectionuploadid";
import { getApiDocumentGetQenotice } from "./getApiDocumentGetQenotice";
import { getApiDocumentGetRequiredDocuments } from "./getApiDocumentGetRequiredDocuments";
import { postApiDocument } from "./postApiDocument";

export function documentController() {
  return {
    postApiDocument,
    getApiDocument,
    deleteApiDocument,
    getApiDocumentGetQenotice,
    getApiDocumentGetRequiredDocuments,
    getApiDocumentGetDocumentElectionuploadid,
    getApiDocumentGetBenefitDocument,
  };
}
